import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../utils/Utils.js';
import { formatDate as formatDateLocale } from '../../utils/dateFormat.js';
import DataCollection from '../shared/DataCollection.js';
import DateInput from '../shared/inputs/DateInput.js';
import { ListButton, AddButton, FAB } from '../shared/ActionButtons';
import WeightLotDropdown from './lots/WeightLotDropdown.js';
import { formatWeightLotId } from './lots/WeightLotDropdown.js';
import SuccessMessage from '../shared/SuccessMessage.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import SlaughterChart from './SlaughterChart.js';
import '../shared/DataCollectionAdd.css';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const s = dateString.length === 10 ? dateString + 'T12:00:00' : dateString;
  const d = new Date(s);
  return isNaN(d) ? dateString : formatDateLocale(d);
};

export const WeightSlaughterActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton  isActive={screen === 'add'}  onClick={() => setScreen('add')}  />
  </div>
);

const AddSlaughter = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [lotId,   setLotId]   = useState('');
  const [date,    setDate]    = useState('');
  const [success, setSuccess] = useState('');
  const [error,   setError]   = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');
    const data = new FormData(e.target);
    const body = {
      lot_code:     formatWeightLotId(Number(lotId), t('weight_lot_prefix')),
      abattoir:     data.get('abattoir') || '',
      yield_pct:    parseFloat(data.get('yield_pct'))    || 0,
      animal_count: parseInt(data.get('animal_count'), 10) || 0,
      date,
    };
    Fetch('api/data/weight.slaughter', 'POST', JSON.stringify(body),
      () => {
        setSuccess(t('slaughter_record_success'));
        e.target.reset();
        setLotId('');
        setDate('');
        setTimeout(onSuccess, 1000);
      },
      () => setError(t('slaughter_record_error'))
    );
  };

  return (
    <form className="DataCollectionAdd" onSubmit={handleSubmit}>
      <WeightLotDropdown
        selected={lotId}
        onChange={e => setLotId(e.target.value)}
        name="lot_id"
      />
      <input name="abattoir"     type="text"   placeholder={t('slaughter_abattoir')} />
      <input name="yield_pct"    type="number" step="0.1" min="0" max="100"
             placeholder={t('slaughter_yield_pct')} required />
      <input name="animal_count" type="number" min="0"
             placeholder={t('slaughter_animal_count')} />
      <DateInput value={date} onChange={setDate} required />
      {success && <SuccessMessage message={success} />}
      {error   && <ErrorMessage  message={error}   />}
      <button type="submit">{t('slaughter_record_button')}</button>
    </form>
  );
};

const ListSlaughter = () => {
  const { t } = useTranslation();

  const columns = [
    { name: t('col_lot_code'),     selector: row => row.lot_code,     sortable: true },
    { name: t('col_abattoir'),     selector: row => row.abattoir,     sortable: true },
    { name: t('date'),             selector: row => row.date,         sortable: true, cell: row => formatDate(row.date) },
    { name: t('col_animal_count'), selector: row => row.animal_count, sortable: true, cell: row => row.animal_count > 0 ? row.animal_count : '—' },
    {
      name: t('col_yield_pct'),
      selector: row => row.yield_pct,
      sortable: true,
      cell: row => row.yield_pct > 0 ? `${row.yield_pct.toFixed(1)}%` : '—',
    },
  ];

  return <DataCollection collection="weight.slaughter" columns={columns} />;
};

export const WeightSlaughter = ({ screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState('list');
  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && (
        <>
          <SlaughterChart />
          <ListSlaughter />
          <FAB onClick={() => setCurrentScreen('add')} />
        </>
      )}
      {currentScreen === 'add' && (
        <AddSlaughter onSuccess={() => setCurrentScreen('list')} />
      )}
    </>
  );
};

export default WeightSlaughter;
